import { render, staticRenderFns } from "./HomocycleRatio.vue?vue&type=template&id=5f0dd226&scoped=true"
import script from "./HomocycleRatio.vue?vue&type=script&lang=js"
export * from "./HomocycleRatio.vue?vue&type=script&lang=js"
import style0 from "./HomocycleRatio.vue?vue&type=style&index=0&id=5f0dd226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0dd226",
  null
  
)

export default component.exports